// extracted by mini-css-extract-plugin
export var fullHeightState = "_55-7";
export var headerCell = "_55-1";
export var loadingStateCell = "_55-4";
export var rowWrapper = "_55-3";
export var standaloneTable = "_55-8";
export var standaloneTableWithBodyFill = "_55-9";
export var stateCell = "_55-5";
export var table = "_55-0";
export var tableBodyFiller = "_55-6";
export var white = "_55-2";